export default __webpack_public_path__ + "static/media/butterfly@2x.0d9a60b9.png";